import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Select } from "antd";
const { Option } = Select;

import store from "../../redux/store";
import * as Actions from "../../redux/actions";

import Loading from "../../components/common/loading";

const NewCatalog = () => {
  const { t } = useTranslation(["data"]);

  const navigate = useNavigate();

  const [catalogName, setCatalogName] = useState();
  const [allCatalogs, setAllCatalogs] = useState([]);
  const [loader, setLoader] = useState(true);

  const [error, setError] = useState(false);
  const [dupName, setDupName] = useState();

  useEffect(() => {
    setLoader(true);
    store.dispatch(Actions.getCatalogos()).then((data) => {

      const catalogs = data.payload.data.catalogs.map((cat) => cat.name.toLowerCase());

      setAllCatalogs(catalogs);
      setLoader(false);
    });
  }, []);

  useEffect(() => {

    if (catalogName) {
    
    }
  }, [catalogName]);

  const handleSubmitLogin = (e) => {
    e.preventDefault();

    if (!catalogName || catalogName === "") {
      setError(true);
    } else if(dupName) {

      return;
      
    } else {
      store
        .dispatch(Actions.createCatalog({ catalogName: catalogName }))
        .then(() => {
          return navigate(`/catalogos/${catalogName}`);
        });
    }
  };

  return (
    <div className="customCatalog">
      <div className="title">{t("crearCatalogo")}</div>
      {allCatalogs && (
        <div className="customCatalog-content">
          <form onSubmit={(e) => handleSubmitLogin(e)}>
            <div className="content-form">
              <div className="catalog-name">
                <label>{t("nombreDelCatalogo")}</label>
                <input
                  type="text"
                  placeholder={t("nombre")}
                  onChange={(e) => {

                    const catalogNameExist = allCatalogs.includes(e.target.value.toLowerCase());

                    if (catalogNameExist) {
                      setDupName(true);
                    } else {
                      setDupName(false);
                      return setCatalogName(e.target.value), setError(false);

                    }
                  }}
                />
                {dupName && (
                  <span className="validation">Ya existe un catálogo con este nombre.</span>
                )}
                {error && (
                  <span className="validation">
                    Nombre de catálogo es obligatorio.
                  </span>
                )}
              </div>
              <div className="submit">
                <input type="submit" value={t("crear")} />
                <button type="button" onClick={() => navigate(`/`)}>Cancelar</button>
              </div>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default NewCatalog;
